// src/pages/About.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutContent from '../components/AboutContent/AboutContent.tsx';
//import Specializations from '../components/Specializations/Specializations.tsx';
//import Testimonials from '../components/Testimonials/Testimonials.tsx';
//import Mission from '../components/Mission/Mission.tsx';


const About: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About Astrologer Kavitha Nandy | Vedic Astrologer | Cosmic Kavi</title>
        <meta name="description" content="Meet Astrologer Kavitha Nandy, professional Vedic astrologer based in Bonney Lake, Washington. Specialising in jyotish, kundali readings, Vaastu Shastra, and birth time rectification. Remote consultations across the USA." />
        <link rel="canonical" href="https://cosmickavi.com/about" />
      </Helmet>
      {/* <section className="page-header">
        <div className="container">
          <h1>About Your Cosmic Guide</h1>
          <p>Discover the journey that led to a lifetime dedication to astrological wisdom</p>
        </div>
      </section> */}
      <AboutContent />
      {/* <Specializations />
      <Testimonials />
      <Mission /> */}
    </>
  );
};

export default About;